import { render, staticRenderFns } from "./confirmEmail.vue?vue&type=template&id=ec8d866a&scoped=true"
import script from "./confirmEmail.vue?vue&type=script&lang=js"
export * from "./confirmEmail.vue?vue&type=script&lang=js"
import style0 from "./confirmEmail.vue?vue&type=style&index=0&id=ec8d866a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8d866a",
  null
  
)

export default component.exports